import PropTypes from 'prop-types';
import { Button, IconButton, Typography, TextareaAutosize } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';
import InvoiceUploader from './components/InvoiceUploader';

export default function UploadInvoiceModal({
  onCloseModal,
  isOpen,
  isLoading = false,
  statementRef,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={isLoading ? null : onCloseModal}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          zIndex: 1000,
        },
        content: {
          position: 'relative',
          paddingBottom: '0px',
          width: '472px',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          padding: '10px',
          borderRadius: '16px',
          boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.3)',
        },
      }}
    >
      <div className="p-[24px]">
        <div className="flex justify-between mb-[24px]">
          <h1 className="text-[24px]">Upload Invoice</h1>
          <IconButton disabled={isLoading} onClick={onCloseModal} size="small" aria-label="edit">
            <CloseIcon color="inherit" />
          </IconButton>
        </div>
        <p className="text-[14px] mb-[24px]">
          Please upload an invoice for the statement we have provided. The invoice must be a PDF
          file and should not exceed 4MB in size.
        </p>
        <InvoiceUploader statementRef={statementRef} onUpload={onCloseModal} />
        <div className="flex justify-end gap-5 pt-4">
          <Button
            disabled={isLoading}
            sx={{ borderRadius: 8, height: '40px', paddingX: '24px' }}
            variant="text"
            color="inherit"
            onClick={onCloseModal}
          >
            <Typography fontSize={14} textTransform={'none'}>
              Close
            </Typography>
          </Button>
        </div>
      </div>
    </Modal>
  );
}

UploadInvoiceModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseModal: PropTypes.func.isRequired,
  onSendAppeal: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  statementRef: PropTypes.string,
};
